<p-carousel
  class="sponsor-carousel"
  [value]="sponsorCards"
  [numVisible]="1"
  [numScroll]="1"
  [autoplayInterval]="sponsorCards.length > 1 ? 20000 : 0"
  [showIndicators]="false"
  [showNavigators]="false"
  [circular]="true">
  <ng-template let-card pTemplate="item">
    <div
      class="sponsor-card"
      [class.cursor-pointer]="card.link"
      (click)="openLink(card)">
      @if (card.image) {
        <img [src]="card.image" alt="Bild" class="image" />
      } @else {
        <div class="image-placeholder">
          <i class="fa-regular fa-image"></i>
        </div>
      }
      <div class="text">
        <div class="title">
          {{ card.title ?? 'Titel' }}
        </div>
        <div class="description">
          {{ card.description ?? 'Hier steht die Beschreibung' }}
        </div>
      </div>
    </div>
  </ng-template>
</p-carousel>
